$(document).ready(function() {
	if(!document.getElementById('inquirytoBuyForm')) return false;
	
	var inquiryToBuy = {
		form: document.getElementById('inquirytoBuyForm'),
		category: document.getElementById('selectProductCategory'),
		target: document.getElementById('appendTarget'),
		locationType: 'NonEU',
		PRODUCT_CATEGORY_MONITOR: 'CT00000233',
		beforeSubmit: function(e) {
			var self = this,
				$form = $(self.form);

			if ($form.checkValidation() && captcha.validation()) {
				$('body').trigger('ajaxLoadBefore');

				if (self.locationType == 'EU') {
					if (!$(self.form).find('#transferoutsideeea').is(':checked')) {
						var name = $(self.form).find('#transferoutsideeea').attr('name');
						$(self.form).append('< input type="hidden" name="' + name + '" value="off" />');
					}
				} else if(self.locationType == 'NonEU'){
					$(self.form).find('#dm_agreement').remove();
					//$(self.form).append('<input type="checkbox" name="transferoutsideeea" id="transferoutsideeea" style="width:0;height:0;overflow:hidden;font-size:0;" checked="checked" />');
					
				}

				if(self.category.value == 'CT00021159'){
					$(self.form).find('input[name="backurl"]').attr('name', 'backUrl');
					if($(self.form).find('input[name="products"]:checked').length > 1){
						$(self.form).append('<input type="hidden" name="products" value="Cross" />');
					
					}
					//BTOBGLOBAL-266 Start
					$(self.form).append('<input type="hidden" name="message" id="messageHide" value="" />');
					$('#messageHide').val( $('#timeStamp').val()+" "+$('#message').val());
					$('#message').prop("name","messageInit");
					//BTOBGLOBAL-266 End
				}

				self.form.submit();
			}

			e.preventDefault();
		},
		/* BTOBGLOBAL-43 20200512 add */
		productCategoryInit: function() {
			var self = this;
			switch (self.category.value) {
				case self.PRODUCT_CATEGORY_MONITOR:
					var $job = $('#jobFunction');
					var tgglProductsTargetValue = $.trim(($('#tgglProductsTarget').val() || ''));
					if (tgglProductsTargetValue) {
						var copy = $job.find('option').map(function(idx, item){
								var txt = $.trim(item.textContent);
								var regex = new RegExp('('+tgglProductsTargetValue+')','g');
								return regex.test(txt) ? null : item.outerHTML;
							}).get().join('');
						self.jobOptionMonitor = copy;
						self.jobOptionMonitorMedical = $job.clone()[0].innerHTML;
						$('#productSolution').trigger('change');
					}
					break;
				default:
					break;
			}
		},
		/* //BTOBGLOBAL-43 20200512 add */
		afterChange: function(e) {
			var self = this,
				$formTarget = $(self.target),
				url = self.category.options[self.category.selectedIndex].getAttribute('data-url');
			/* BTOBGLOBAL-200 add*/
			if(url==null || url==""){
				$formTarget.empty();
				return false;
			}
			/* //BTOBGLOBAL-200 add*/
			/* LGEGMC-144 20200414 add */
			self.setAdobeValueAttr($(e.target));
			/*//LGEGMC-144 20200414 add */

			/* BTOBGLOBAL-43 20200601 add */
			var param = {};
			var $objective = $('#objective');
			self.objectiveTriggerFlag = !!$objective.length;
			if (self.category.value === 'CT00000279' && $objective.length) { // select category : solar
				param.solarObjective = $.trim($objective.find('option:selected').text());
				param.solarObjectiveView = $objective.find('option:selected').data('objective');
			}
			/* //BTOBGLOBAL-43 20200601 add */
			
			/* BTOBGLOBAL-245 20201127 start */
			param.selectItem = $('input[name="selectItem"]').val();
			param.modelId = $('input[name="modelId"]').val();
			/* BTOBGLOBAL-245 20201127 end */
			
			$.ajax({
				type: 'post',
				url: url,
				data: param,
				dataType: 'html',
				beforeSend: function() {
					$('body').trigger('ajaxLoadBefore');
				},
				success: function(data) {
					if (data) {
						var categoryName = $(self.category).find('option:selected').text();

						$(self.form).find('input[name="categoryName"]').val(categoryName);
						$formTarget.html(data);

						if (!$formTarget.find('iframe').length) {
							self.form.action = $formTarget.find('input[name="Non-EU"]').val();
							self.formInit();
							
							//BTOBGLOBAL-245 start
							if ($('input[name="existCategoryId"]').val()) {
								$("#productSolution").trigger('chosen:updated');
							}
							if ($('input[name="existSeriesName"]').val()) {
								$("#series").trigger('chosen:updated');
							}
							if ($('input[name="existModelId"]').val()) {
								$("#model").trigger('chosen:updated');
							}
							if ($('input[name="existRegionName"]').val()) {
								$("#region").trigger('chosen:updated');
							}
							if ($('input[name="existCountryName"]').val()) {
								$("#country").prop('disabled', false);
								$("#country").trigger('chosen:updated');
							}
							//BTOBGLOBAL-245 end
							
							$('body').trigger('ajaxLoadEnd');
						} else {
							var itFlag = true;
							
							/* BTOBGLOBAL-918 Start */
							if (self.PRODUCT_CATEGORY_MONITOR === self.category.value){
								var itCateName = $('input[name="itCateName"]').val();
								
								if(itCateName != ""){
									$formTarget.find('#selectCategoryOptionIT').find('[data-type='+itCateName+']').prop("selected", true);
									$formTarget.find('#destination-frame').attr('src', $formTarget.find('#selectCategoryOptionIT').find('[data-type='+itCateName+']').val());
									
									$('input[name="itCateName"]').val('');									
								}
							}
							/* BTOBGLOBAL-918 End */
							
							$formTarget.find('iframe').on('load', function() {
								runChosen(); /* BTOBGLOBAL-50 20200619 add */
								chosenScrollInit();
								$('body').trigger('ajaxLoadEnd');
								/* BTOBGLOBAL-50, BTOBGLOBAL-354 ,LGEGMC-945 Start */
								$formTarget.find('#selectCategoryOption').off('change').change(function(){
									$formTarget.find('#destination-frame').attr('src',$(this).val());
									});
								$formTarget.find('#selectCategoryOptionIT').off('change').change(function(){
									$formTarget.find('#destination-frame').attr('src',$(this).val());
									var optionCategory = $formTarget.find('#selectCategoryOptionIT option:checked').text();
									self.getEloquaData(self.category.value, optionCategory);
									itFlag=false;
								});
								/* BTOBGLOBAL-50, BTOBGLOBAL-354, LGEGMC-945 End */
								
								/* LGEGMC-945 Start */
								if(itFlag){
									var optionCategory = $formTarget.find('#selectCategoryOptionIT option:checked').text();
									if(!!optionCategory){
										self.getEloquaData(self.category.value, optionCategory);
									}else{
										self.getEloquaData(self.category.value);
									}
								}
								/*// LGEGMC-945 End */
							});
						}
						self.productCategoryInit(); /* BTOBGLOBAL-43 20200513 add */
					}
				},
				error: function(request, status, error) {

				}
			});
		},
		formInit: function() {
			var self = this,
				$formTarget = $(self.target),
				$textarea = $formTarget.find('textarea[maxlength]'),
				$select = $formTarget.find('select');
			self.locationType = 'NonEU';

			if ($textarea.length > 0) {
				checkTextLength($textarea, $textarea.parent().find('.left-text .count'));
			}

			if ($select.length > 0) {
				runChosen();
				chosenScrollInit();
			}
			
			/* BTOBGLOBAL-182 START */
			var $sourceTarget = $formTarget.find('input[name="source"]');
			var sourceValue = $(self.form).find('input[name="sourceValue"]').val();
			if(sourceValue != null && sourceValue != "" && $sourceTarget.length > 0){
				$sourceTarget.val(sourceValue);
			}
			/* BTOBGLOBAL-182 END */
			
		},
		/* BTOBGLOBAL-245 start */
		productSolutionChange: function(e) {
			var $productSolution = $(e.currentTarget);
			$.ajax({
				type: 'post',
				url: $productSolution.data('url'),
				dataType: 'json',
				data: "productSolution="+$productSolution.val(),
				success: function(data) {
					if (data.result) {
						$('input[name=selectedProductSolution]').val($productSolution.val());
						$('#productSolutionName').val($('#productSolution_chosen span').text());					
						$('input[name=seriesName]').val('');
						$('input[name=modelName]').val('');
						var $target = $('#series'),
							list = data.seriesList,
							option = '<option value="" selected disabled>' + $target.data('placeholder') + '</option>';

						for (var i  in list) {
							option += '<option value="' + list[i].code + '">' + list[i].value + '</option>'
						}
						
						$target.html(option);
						$target.prop('disabled', false);
						$target.trigger('chosen:updated');
						
						var $modelTarget = $('#model'),
						     modelOption = '<option value="" selected disabled>' + $modelTarget.data('placeholder') + '</option>';
						$modelTarget.html(modelOption);
						$modelTarget.prop('disabled', false);
						$modelTarget.trigger('chosen:updated');
					}
				}
			});
		},		
		seriesChange: function(e) {
			var $series = $(e.currentTarget);
			var selectedProductSolution = $('input[name=selectedProductSolution]').val();
			$.ajax({
				type: 'post',
				url: $series.data('url'),
				dataType: 'json',
				data: "series="+$('#series_chosen span').text()+"&productSolution="+selectedProductSolution,
				success: function(data) {
					if (data.result) {
						$('input[name=seriesName]').val($('#series_chosen span').text());
						$('input[name=modelName]').val('');
						var $target = $('#model'),
							seriesVal = $series.val(),
							list = data.modelNameList,
							option = '<option value="" selected disabled>' + $target.data('placeholder') + '</option>';

						for (var i  in list) {
							option += '<option value="' + list[i].code + '">' + list[i].value + '</option>'
						}
						
						$target.html(option);
						$target.prop('disabled', false);
						$target.trigger('chosen:updated');
					}
				}
			});
		},
		modelChange: function(e) {
			var $model = $(e.currentTarget);
			$('input[name=modelName]').val($('#model_chosen span').text());
		},
		/* BTOBGLOBAL-245 end */
		regionChange: function(e) {
			var self = this,
				$region = $(e.currentTarget);

			$.ajax({
				type: 'post',
				url: $region.data('url'),
				dataType: 'json',
				data: $region.serialize(),
				success: function(data) {
					if (data.result) {
						var $target = $('#country'),
                        	$stateTarget = $('#state'),
                        	$countryTarget = document.getElementById('globalcountry'),
							$usStateTarget = $('.type-state'),
							$formTarget = $(self.target),	
							list = data.countryList,
							option = '<option value="" selected disabled>' + $target.data('placeholder') + '</option>',
							stateOption = '<option value="" selected disabled>' + $stateTarget.data('placeholder') + '</option>';
						
						for (var i  in list) {
							option += '<option value="' + list[i].code + '">' + list[i].value + '</option>'
						}

						$target.html(option);
						$target.prop('disabled', false);
						$target.trigger('chosen:updated');

						var val = $region.val(),
							action = '';
						
						if (val == 'Europe' && self.locationType == 'NonEU') {
							action = $formTarget.find('input[name="EU"]').attr('value')
							self.locationType = 'EU';
							
							$formTarget.find('.privacy-policy.type-a').hide();
							$formTarget.find('.privacy-policy.type-b').show();
						
							$formTarget.find('.privacy-policy').find('input[type="checkbox"]').prop('checked', false);
							$(self.form).attr('action', action);	
						} else if (val != 'Europe' && self.locationType == 'EU') {
							action = $formTarget.find('input[name="Non-EU"]').attr('value')
							self.locationType = 'NonEU';

							$formTarget.find('.privacy-policy.type-a').show();
							$formTarget.find('.privacy-policy.type-b').hide();
							
							$formTarget.find('.privacy-policy').find('input[type="checkbox"]').prop('checked', false);
							$(self.form).attr('action', action);
						}
						
						/* BTOBGLOBAL-175 add*/
						if (val == "North America") {
							$countryTarget.className  = "col-sm-6";
							$usStateTarget.show();
						} else {
							$countryTarget.className  = "col-sm-12";
							$usStateTarget.hide();
							$stateTarget.html(stateOption);
							$stateTarget.prop('disabled', true);
							$stateTarget.trigger('chosen:updated');
						}
						
					}
				}
			});
		},
		countryChange: function(e) {
			/* BTOBGLOBAL-175 add*/
			var $country = $(e.currentTarget);
			
			$.ajax({
				type: 'post',
				url: $country.data('url'),
				dataType: 'json',
				data: $country.serialize(),
				success: function(data) {
					if (data.result) {
						var $target = $('#state'),
							countryVal = $country.val(),
							stateList = data.stateList,
							option = '<option value="" selected disabled>' + $target.data('placeholder') + '</option>';
						

						if(countryVal == "United States"){
							
							for (var i  in stateList) {
								option += '<option value="' + stateList[i].commonCodeId + '">' + stateList[i].commonCodeId + '</option>';
							}	
							
							$target.html(option);
							$target.prop('disabled', false);
							$target.trigger('chosen:updated');
						} else {
							$target.html(option);
							$target.prop('disabled', true);
							$target.trigger('chosen:updated');
						}
						
					}
				}
			});
		},
		addEvent: function() {
			var self = this;

			$(self.category).on('change', $.proxy(self.afterChange, self));
			$(self.form).on('submit', $.proxy(self.beforeSubmit, self))
						.on('change', function(e) {
							var $target = $(e.target);
							
							/* LGEGMC-144 20200414 add */
							if (/(products|inquiryType)/.test($target[0].name) && $target[0].tagName === 'SELECT') {
								self.setAdobeValueAttr($target);
							}
							/* /LGEGMC-144 20200414 add */

							/* BTOBGLOBAL-43 20200601 add */
							var selectMonitorProducts = 'products' === $target[0].name && $target[0].tagName === 'SELECT' && self.PRODUCT_CATEGORY_MONITOR === self.category.value;
							if (selectMonitorProducts) {
								var $jobFunction = $('#jobFunction');
								var tgglProducts = $.trim(($('#tgglProducts').val() || ''));
								$jobFunction[0].innerHTML = ( tgglProducts === $target.val() ) ? self.jobOptionMonitorMedical : self.jobOptionMonitor;
								$jobFunction.trigger("chosen:updated");
							}
							
							if ('objective' === $target[0].name) {
								if ($target.prop('selectedIndex') === 1 && !self.objectiveTriggerFlag) {
									return;
								}
								$(self.category).trigger('change');
							}
							/* //BTOBGLOBAL-43 20200601 add */
						}); 
			
			$(self.target).on('keypress', '#budget', function(evt) {
				var charCode = (evt.which) ? evt.which : event.keyCode;

				if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
					return false;   

				var _value = event.srcElement.value;    

				var _pattern0 = /^\d*[.]\d*$/;
				if (_pattern0.test(_value)) {
					if (charCode == 46) {
						return false;
					}
				}
			});
			$(self.target).on('keyup', '#budget', function() {
				this.value = this.value.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');
			});
			$(self.target).on('input mouseup mouseenter', 'input, textarea', function() { 
				var $this = $(this),
					val = $this.val();
					
				$this.val(xssfilter(val, 'form'));
			});
			$(document).on('change', '#region', $.proxy(self.regionChange, self));
			/* BTOBGLOBAL-39 : 20200413 add */
			$(document).on('click', 'input[name=allAgree]', function(){
				var $checkbox = $(this).closest('.privacy-policy').find('input[type=checkbox]'); 
				$checkbox.prop('checked', $(this).is(':checked'));
			});

			$(document).on('click', '.privacy-policy .write-list-wrap input[type=checkbox]', function(){
			    if(!$(this).is(':checked')){
			        $(this).closest('.privacy-policy').find('input[name=allAgree]').prop('checked', false);
			    }
			});
			/*// BTOBGLOBAL-39 : 20200413 add */
			
			/* BTOBGLOBAL-175 add*/
			$(document).on('change', '#country', $.proxy(self.countryChange, self));
			
			/* BTOBGLOBAL-245 start */
			$(document).on('change', '#productSolution', $.proxy(self.productSolutionChange, self));
			$(document).on('change', '#series', $.proxy(self.seriesChange, self));
			$(document).on('change', '#model', $.proxy(self.modelChange, self));
			/* BTOBGLOBAL-245 end */
		},
		init: function(){
			var self = this;

			self.addEvent();

			$(self.category).trigger('change');

			if($('#jobFunction').length > 0){
				chosenScrollInit();
			}
			
			// BTOBGLOBAL-399 , BTOBGLOBAL-788 Start
			var requestUri = $(self.form).find('input[name="backurl"]').val();
			if (requestUri == '/global/business/integrated-solutions/inquiry-to-buy' || requestUri == '/global/business/thinqhome/inquiry-to-buy' || requestUri == '/global/business/healthcare/inquiry-to-buy') {
				var selectCategoryName = $(self.category).find('option:selected').text();
				if (selectCategoryName == 'Select Category') {
					$(self.category).val('CT00021159').prop("selected", true);
					$(self.category).trigger('change');
					$(self.category).trigger('chosen:updated');
				}
			}
			// BTOBGLOBAL-399 , BTOBGLOBAL-788 End
			// BTOBGLOBAL-799 Start
			else if(requestUri == '/global/business/robot/inquiry-to-buy'){
				var selectCategoryName = $(self.category).find('option:selected').text();
				if (selectCategoryName == 'Select Category') {
					$(self.category).val('CT40011011').prop("selected", true);
					$(self.category).trigger('change');
					$(self.category).trigger('chosen:updated');				
				}
			}
			//BTOBGLOBAL-799 End
		},
		/* LGEGMC-144 20200423 add */
		setAdobeValueAttr: function($target) {
			var self = this; // LGEGMC-945
			var val = $.trim($target.val());
			var tit = val ? $.trim($target.find('option:selected').text()) : '';
			$target.attr('adobe-value',tit);

			if (val) {
				var paramMap = {
					selectProductCategory:  'inquiry_to_buy_product_category_select',
					productSolution:		'inquiry_to_buy_product_solution_select',
					products:				'inquiry_to_buy_product_solution_select',
					inquiryType:			'inquiry_to_buy_inquiry_type_select'
				};

				self.setClassificationCode(val); // LGEGMC-945
				
				var paramName = paramMap[$target[0].name];
				var param = {};
				param.page_event = {};

				param[paramName] = tit;
				// LGEGMC-585
				param.level1 = (typeof standardData === "undefined") ? '' : standardData.level1;
				param.level2 = (typeof standardData === "undefined") ? '' : standardData.level2;
				/* LGEGMC-945 Start */
				if('inquiry_to_buy_product_category_select' != paramName){
					param.level3 = (typeof standardData === "undefined") ? '' : standardData.level3;
				}
				/*// LGEGMC-945 End */
				// LGEGMC-585 End
				param.page_event[paramName] = true;
				adobeTrackEvent(paramName, param);
			}
		},
		/*//LGEGMC-144 20200423 add */
		/* LGEGMC-945 Start */
		setClassificationCode: function(categoryId){
			if(typeof standardData != 'undefined'){
				var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/retrieveCategoryBuInfo?bizType=B2B&categoryId='+categoryId;
				$.ajax({
					type:"post",
					url: url,
					dataType: "json",
					async: false,
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						standardData.level1 = data.data[0].buName.buName1;
						standardData.level2 = data.data[0].buName.buName2;
						standardData.level3 = data.data[0].buName.buName3;
					},
					error: function(request,status,error) {
						console.log("status: "+status);
						console.log("error: "+error);
					}
				});
			}
		},
		getEloquaData: function(superCategoryId,optionCategory){
			if(!document.getElementsByClassName('gpEloquaForm')[0]){
				return;
			}
			var iframe = document.getElementsByClassName('gpEloquaForm')[0].contentWindow;
			
			var object = {};
			object['superCategoryId'] = superCategoryId;
			if(optionCategory){
				object['categoryName'] = $.trim(optionCategory);
			}
			if(!!superCategoryId){
				var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/inquirytobuy/getEloquaData';
				$.ajax({
					type:"post",
					url: url,
					data: object,
					dataType: 'json',
					async: false,
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						if(data.result){
							console.log('Eloqua data search success');
							setTimeout(function() {
								iframe.postMessage(data,'*');
							}, 2000);
						}else{
							console.log('no Eloqua data');
						}
					},
					error: function(request,status,error) {
						console.log("status: "+status);
						console.log("error: "+error);
					}
				});
			}
		},
		/*// LGEGMC-945 End */
		/* BTOBGLOBAL-133 Start */
		itbIframeReady:function(e){
		    if (e.data.EloquaIframe !== 'ready') {
		      return;
		    }
		    
			var iframe = document.getElementsByClassName('gpEloquaForm')[0].contentWindow;
			var countryCode = COUNTRY_CODE.toLowerCase();
			      var acVal =
			        document.cookie.match(`(^|;) ? ${countryCode}_LGCOM_ANALYSIS_OF_SITE=([^;]*)(;|$)`) &&
			        document.cookie.match(`(^|;) ? ${countryCode}_LGCOM_ANALYSIS_OF_SITE=([^;]*)(;|$)`)[2] === 'N'
			          ? 'N'
			          : 'Y';
					  
					  
			console.log('acVal======', acVal);
			iframe.postMessage({ OPTOUT: acVal }, '*');
		} 
		/* BTOBGLOBAL-133 End */
	};
	inquiryToBuy.init();
	window.addEventListener('message', inquiryToBuy.itbIframeReady, false);
	
});
